import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from '../configs/authConfig';

export const msalInstance = new PublicClientApplication(msalConfig);